/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetGradingStatsReportParams = {
  /**
   * Inclusive range start (ISO datetime)
   */
  from: string;
  /**
   * Exclusive range end (ISO datetime)
   */
  to: string;
  lecturer_id?: string | null;
};
